import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Gem, Mail, ArrowLeft } from "lucide-react";
import api, { apiError } from "@/lib/api";

export default function ForgotUsername() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-username", { email });
      toast.success(data.message);
      setSent(true);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#050507] p-6" data-testid="forgot-username-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-10 h-10 rounded-xl gold-btn grid place-items-center"><Gem className="w-5 h-5 text-black" /></div>
          <div className="font-display font-extrabold text-lg">Money<span className="gold-text">MoonX</span></div>
        </Link>
        <div className="glass rounded-2xl p-8 border border-amber-500/20">
          <h1 className="font-display text-2xl font-bold">Forgot username</h1>
          <p className="text-slate-400 mt-2 text-sm">Enter your account email and we'll send your username to it.</p>
          {sent ? (
            <div className="mt-6 rounded-xl bg-emerald-500/10 border border-emerald-500/25 p-4 text-sm text-emerald-300" data-testid="forgot-username-sent">
              If that email is registered, your username is on its way. Check your inbox.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-sm text-slate-400">Email</label>
                <input data-testid="forgot-username-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-1.5 bg-[#0D0E12] border border-amber-500/20 focus:border-amber-500 rounded-xl px-4 py-3 outline-none" placeholder="you@email.com" />
              </div>
              <button data-testid="forgot-username-submit-btn" disabled={busy} className="gold-btn w-full py-3.5 rounded-xl font-bold flex items-center justify-center gap-2 disabled:opacity-60">
                <Mail className="w-5 h-5" /> {busy ? "Sending..." : "Send my username"}
              </button>
            </form>
          )}
          <Link to="/login" className="mt-6 flex items-center gap-1.5 text-sm text-amber-400 hover:text-amber-300 justify-center">
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
